<template>
    <div>
        <el-form-item :label="form.title">
            <template v-if="form.type === 'image' || form.type === 'images'">
                <upload v-model="form.value" v-model:checkedData="form.file_path" :button="form.type === 'image' ? '上传单张图片' : '上传多张图片'" :is-multiple="form.type === 'images' ? true : false" dir="images" />
            </template>

            <template v-if="form.type === 'file' || form.type === 'files'">
                <upload v-model="form.value" v-model:checkedData="form.file_path" :button="form.type === 'file' ? '上传单个文件' : '上传多个文件'" :is-multiple="form.type === 'files' ? true : false" dir="files" />
            </template>

            <template v-if="form.type === 'text'">
                <el-input
                    v-model="form.value"
                    :name="form.name"
                    clearable
                    :disabled="form.attr ? form.attr.disabled : false"
                    :size="form.attr ? form.attr.size : ''"
                    :minlength="form.attr ? form.attr.minlength : ''"
                    :maxlength="form.attr ? form.attr.maxlength : ''"
                    :placeholder="form.placeholder">
                    <template #prepend v-if="form.slot && form.slot[0]">
                        <text v-if="form.slot[0].indexOf('icon:') > -1">
                            <ui-icon v-if="form.slot[0].slice(5)" :type="form.slot[0].slice(5)" />
                        </text>
                        <text v-else>{{form.slot[0]}}</text>
                    </template>
                    <template #append v-if="form.slot && form.slot[1]">
                        <text v-if="form.slot[1].indexOf('icon:') > -1">
                            <ui-icon v-if="form.slot[1].slice(5)" :type="form.slot[1].slice(5)" />
                        </text>
                        <text v-else>{{form.slot[1]}}</text>
                    </template>
                </el-input>
            </template>

            <template v-if="form.type === 'static'">
                <el-input v-model="form.value" disabled :size="form.attr ? form.attr.size : ''"/>
            </template>

            <template v-if="form.type === 'password'">
                <el-input
                    v-model="form.value"
                    :name="form.name"
                    type="password"
                    show-password
                    :disabled="form.attr ? form.attr.disabled : false"
                    :size="form.attr ? form.attr.size : ''"
                    :minlength="form.attr ? form.attr.minlength : ''"
                    :maxlength="form.attr ? form.attr.maxlength : ''"/>
            </template>

            <template v-if="form.type === 'textarea' || form.type === 'array'">
                <el-input
                    v-model="form.value"
                    :name="form.name"
                    clearable
                    :autosize="{ minRows: 2, maxRows: 4 }"
                    type="textarea"
                    :disabled="form.attr ? form.attr.disabled : false"
                    :size="form.attr ? form.attr.size : ''"
                    :minlength="form.attr ? form.attr.minlength : ''"
                    :maxlength="form.attr ? form.attr.maxlength : ''"
                    :placeholder="form.placeholder" />
            </template>

            <template v-if="form.type === 'switch'">
                <el-switch
                    v-model="form.value"
                    :name="form.name"
                    active-value="1"
                    inactive-value="0"
                    :disabled="form.attr ? form.attr.disabled : false"
                    :size="form.attr ? form.attr.size : ''"
                    :style="`--el-switch-on-color: ${form.attr && form.attr.coloron ? form.attr.coloron : ''}; --el-switch-off-color: ${form.attr && form.attr.coloroff ? form.attr.coloroff : ''}`"/>
            </template>

            <template v-if="form.type === 'radio'">
                <el-radio-group :disabled="form.disabled" v-model="form.value" :name="form.name" :fill="form.attr ? form.attr.fill : ''" :text-color="form.attr ? form.attr.textcolor : ''">
                    <template v-if="form.attr && form.attr.shape === 'button' ? true : false">
                        <template v-for="(item, index) in form.options" :key="index">
                            <template v-if="typeof(item) == 'string' || typeof(item) == 'number'">
                                <el-radio-button
                                    :label="isNaN(Number(index)) === false ? Number(index) : index"
                                    :size="form.attr ? form.attr.size : ''"
                                    :disabled="typeof(item) == 'string' ? item.indexOf('disabled:') > -1 : false">
                                    <text v-if="typeof(item) == 'string' ? item.indexOf('disabled:') > -1 : false">{{ item.slice(9) }}</text>
                                    <text v-else>{{ item }}</text>
                                </el-radio-button>
                            </template>
                            <template v-else>
                                <el-radio-button
                                    :label="item[form.config.value]"
                                    :size="form.attr ? form.attr.size : ''"
                                    :disabled="item.disabled">
                                    <text>{{ item[form.config.key] }}</text>
                                </el-radio-button>
                            </template>
                        </template>
                    </template>
                    <template v-else>
                        <template v-for="(item, index) in form.options" :key="index">
                            <template v-if="typeof(item) == 'string' || typeof(item) == 'number'">
                                <el-radio
                                    :label="isNaN(Number(index)) === false ? Number(index) : index"
                                    :size="form.attr ? form.attr.size : ''"
                                    :border="form.attr && form.attr.shape === 'border' ? true : false"
                                    :disabled="typeof(item) == 'string' ? item.indexOf('disabled:') > -1 : false">
                                    <text v-if="typeof(item) == 'string' ? item.indexOf('disabled:') > -1 : false">{{ item.slice(9) }}</text>
                                    <text v-else>{{ item }}</text>
                                </el-radio>
                            </template>
                            <template v-else>
                                <el-radio
                                    :label="item[form.config.value]"
                                    :size="form.attr ? form.attr.size : ''"
                                    :border="form.attr && form.attr.shape === 'border' ? true : false"
                                    :disabled="item.disabled">
                                    <text>{{ item[form.config.key] }}</text></el-radio>
                            </template>
                        </template>
                    </template>
                </el-radio-group>
            </template>

            <template v-if="form.type === 'checkbox'">
                <el-checkbox-group
                    :disabled="form.disabled"
                    v-model="form.value"
                    :name="form.name"
                    :min="form.attr ? form.attr.min : 0"
                    :max="form.attr ? form.attr.max : 999999"
                    :fill="form.attr ? form.attr.fill : ''"
                    :text-color="form.attr ? form.attr.textcolor : ''">
                    <template v-if="form.attr && form.attr.shape === 'button'">
                        <template v-for="(item, index) in form.options" :key="index">
                            <template v-if="typeof(item) == 'string' || typeof(item) == 'number'">
                                <el-checkbox-button
                                    :label="isNaN(Number(index)) === false ? Number(index) : index"
                                    :size="form.attr ? form.attr.size : ''"
                                    :disabled="typeof(item) == 'string' ? item.indexOf('disabled:') > -1 : false">
                                    <text v-if="typeof(item) == 'string' ? item.indexOf('disabled:') > -1 : false">{{ item.slice(9) }}</text>
                                    <text v-else>{{ item }}</text>
                                </el-checkbox-button>
                            </template>
                            <template v-else>
                                <el-checkbox-button
                                    :label="item[form.config.value]"
                                    :size="form.attr ? form.attr.size : ''"
                                    :disabled="item.disabled">
                                    <text>{{ item[form.config.key] }}</text>
                                </el-checkbox-button>
                            </template>
                        </template>
                    </template>
                    <template v-else>
                        <template v-for="(item, index) in form.options" :key="index">
                            <template v-if="typeof(item) == 'string' || typeof(item) == 'number'">
                                <el-checkbox
                                    :label="isNaN(Number(index)) === false ? Number(index) : index"
                                    :size="form.attr ? form.attr.size : ''"
                                    :border="form.attr && form.attr.shape === 'border' ? true : false"
                                    :disabled="typeof(item) == 'string' ? item.indexOf('disabled:') > -1 : false">
                                    <text v-if="typeof(item) == 'string' ? item.indexOf('disabled:') > -1 : false">{{ item.slice(9) }}</text>
                                    <text v-else>{{ item }}</text>
                                </el-checkbox>
                            </template>
                            <template v-else>
                                <el-checkbox
                                    :label="item[form.config.value]"
                                    :size="form.attr ? form.attr.size : ''"
                                    :border="form.attr && form.attr.shape === 'border' ? true : false"
                                    :disabled="item.disabled">
                                    <text>{{ item[form.config.key] }}</text>
                                </el-checkbox>
                            </template>
                        </template>
                    </template>

                </el-checkbox-group>
            </template>

            <template v-if="form.type === 'select'">
                <el-select
                    v-model="form.value"
                    :name="form.name"
                    clearable
                    filterable
                    default-first-option
                    :reserve-keyword="false"
                    :disabled="form.attr && form.attr.disabled ? true : false"
                    :placeholder="form.placeholder"
                    :size="form.attr ? form.attr.size : ''"
                    :multiple="form.attr && form.attr.multiple ? true : false"
                    :fit-input-width="form.attr && form.attr.fitinputwidth ? true : false"
                    :allow-create="form.attr && form.attr.is_create ? true : false"
                    :placement="form.attr ? form.attr.placement : ''">
                    <template v-for="(item, index) in form.options" :key="index">
                        <template v-if="typeof(item) == 'string' || typeof(item) == 'number'">
                            <el-option
                                :label="item"
                                :value="index"
                                :disabled="typeof(item) == 'string' ? item.indexOf('disabled:') > -1 : false">
                                <text v-if="typeof(item) == 'string' ? item.indexOf('disabled:') > -1 : false">{{ item.slice(9) }}</text>
                                <text v-else>{{ item }}</text>
                            </el-option>
                        </template>
                        <template v-else>
                            <el-option
                                :label="item[form.config.key]"
                                :value="item[form.config.value]"
                                :disabled="item.disabled">
                                <text v-if="item.title_display" v-html="item.title_display" />
                                <text v-else>{{ item[form.config.key] }}</text>
                            </el-option>
                        </template>
                    </template>
                </el-select>
            </template>

            <template v-if="form.type === 'select_group'">
                <el-select
                    v-model="form.value"
                    :name="form.name"
                    clearable
                    filterable
                    default-first-option
                    :reserve-keyword="false"
                    :disabled="form.attr && form.attr.disabled ? true : false"
                    :placeholder="form.placeholder"
                    :size="form.attr ? form.attr.size : ''"
                    :multiple="form.attr && form.attr.multiple ? true : false"
                    :fit-input-width="form.attr && form.attr.fitinputwidth ? true : false"
                    :allow-create="form.attr && form.attr.is_create ? true : false"
                    :placement="form.attr ? form.attr.placement : ''">
                    <el-option-group v-for="(items, indexs) in form.options" :key="items.label" :label="items.label">
                        <template v-for="(item, index) in items.options" :key="index">
                            <template v-if="typeof(item) == 'string' || typeof(item) == 'number'">
                                <el-option
                                    :label="item"
                                    :value="isNaN(Number(index)) === false ? Number(index) : index"
                                    :disabled="typeof(item) == 'string' ? item.indexOf('disabled:') > -1 : false">
                                    <text v-if="typeof(item) == 'string' ? item.indexOf('disabled:') > -1 : false">{{ item.slice(9) }}</text>
                                    <text v-else>{{ item }}</text>
                                </el-option>
                            </template>
                            <template v-else>
                                <el-option
                                    :label="item[form.config.key]"
                                    :value="item[form.config.value]"
                                    :disabled="item.disabled">
                                    <text v-if="item.title_display" v-html="item.title_display" />
                                    <text v-else>{{ item[form.config.key] }}</text>
                                </el-option>
                            </template>
                        </template>
                    </el-option-group>

                </el-select>
            </template>

            <template v-if="form.type === 'select_ajax'">
                <select-ajax :formobj="form"></select-ajax>
            </template>

            <template v-if="form.type === 'linkage'">
                <linkage :forms="form" :formobj="formobj"></linkage>
            </template>

            <template v-if="form.type === 'date' || form.type === 'datetime'">
                <el-date-picker v-model="form.value" :name="form.name" :type="form.pickertype" placeholder="请选择" :format="form.format" :value-format="form.format" :disabled="form.attr && form.attr.disabled ? true : false" :size="form.attr && form.attr.size ? form.attr.size : 'default'" />
            </template>

            <template v-if="form.type === 'daterange' || form.type === 'datetimerange'">
                <el-date-picker v-model="form.value" :name="form.id" :type="form.pickertype" placeholder="请选择" :format="form.format" :value-format="form.format" :disabled="form.attr && form.attr.disabled ? true : false" :size="form.attr && form.attr.size ? form.attr.size : 'default'" :range-separator="form.attr && form.attr.rangeseparator ? form.attr.rangeseparator : '-'" />
            </template>

            <template v-if="form.type === 'time'">
                <el-time-picker v-model="form.value" :name="form.name" placeholder="请选择" :format="form.format" :value-format="form.format" :disabled="form.attr && form.attr.disabled ? true : false" :size="form.attr && form.attr.size ? form.attr.size : 'default'" />
            </template>

            <template v-if="form.type === 'color_picker'">
                <color-picker :formobj="form"></color-picker>
            </template>

            <template v-if="form.type === 'slider'">
                <el-slider
                    v-model="form.value"
                    :size="form.attr ? form.attr.size : ''"
                    :range="form.attr ? form.attr.range : ''"
                    :min="form.attr ? form.attr.min : ''"
                    :max="form.attr ? form.attr.max : ''"
                    :disabled="form.attr ? form.attr.disabled : false"
                    :show-stops="form.attr ? form.attr.show_stops : ''"
                    :marks="form.attr ? form.attr.marks : ''"
                    :step="form.attr ? form.attr.step : ''" />
            </template>

            <template v-if="form.type === 'bmap'">
                <b-map :forms="form" :formobj="formobj"></b-map>
            </template>

            <template v-if="form.type === 'ueditor'">
                <ueditor v-model="form.value"></ueditor>
            </template>

            <template v-if="form.type === 'cascader'">
                <cascader
                    clearable
                    v-model="form.value"
                    :attr="form.attr"
                    :config="form.config"
                    :form-options="form.options" />
            </template>

            <template v-if="form.type === 'icon'">
                <icon v-model="form.value" :attr="form.attr"></icon>
            </template>

            <template v-if="form.type === 'wangeditor'">
                <wangeditor v-model="form.value" :attr="form.attr"></wangeditor>
            </template>

            <template v-if="form.type === 'transfer'">
                <el-transfer
                    v-model="form.value"
                    :filterable="form.attr ? form.attr.filterable : ''"
                    :filter-placeholder="form.attr ? form.attr.filter_placeholder : ''"
                    :titles="form.attr ? form.attr.titles : ''"
                    :button-texts="form.attr ? form.attr.button_texts : ''"
                    :data="form.options"
                    :props="form.config" />
            </template>
            <template v-if="form.type === 'form_table'">
                <formtable
                    ref="table"
                    v-model="form.value"
                    :forms="form"
                    :add-template="form.config.template"
                    :drag-sort="form.config.is_drag"
                    :hide-add="form.config.is_hide_add"
                    :hide-delete="form.config.is_hide_delete"
                    placeholder="暂无数据">
                </formtable>
            </template>

            <template v-if="form.tips">
                <div class="help-block" v-html="form.tips" />
            </template>
        </el-form-item>
    </div>
</template>

<script>
    import { getCurrentInstance, defineComponent, ref, inject, watch } from 'vue'
    import Upload from '../ui-upload'
    import SelectAjax from './items/selectajax'
    import ColorPicker from './items/colorpicker'
    import BMap from './items/bmap'
    import Ueditor from '../ui-ueditor'
    import Cascader from './items/cascader'
    import Icon from './items/icon'
    import Wangeditor from '../ui-wangeditor'
    import Linkage from './items/linkage'
    import Formtable from './items/formtable'

    export default defineComponent({
        components: {
            Upload,
            SelectAjax,
            ColorPicker,
            BMap,
            Ueditor,
            Cascader,
            Icon,
            Wangeditor,
            Linkage,
            Formtable
        },
        props: {
            forms: {
                type: [Array, Object],
                default: () => {}
            },
            formobj: {
                type: [Array, Object],
                default: () => {}
            }
        },
        setup(props, context) {
            const { proxy } = getCurrentInstance()
            const form = ref(props.forms)

            return {
                form
            }
        }
    })
</script>

<style scoped>

</style>
